import { render, staticRenderFns } from "./DonutChart16.vue?vue&type=template&id=ee9620c4&scoped=true&"
import script from "./DonutChart16.vue?vue&type=script&lang=js&"
export * from "./DonutChart16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee9620c4",
  null
  
)

export default component.exports